import { v7 as uuid } from 'uuid';
const AJAX_REQUEST = 'AJAX/REQUEST';
const AJAX_RESPONSE = 'AJAX/RESPONSE';
const DEFAULT_REQUEST_TIMEOUT = 30000;
// What a core plugin content script answers when it's left over from before
const EXTENSION_CONTEXT_INVALIDATED = 'Extension context invalidated.';
class Messaging {
    constructor(params) {
        this.origin = '*';
        this.pendingRequests = new Map();
        this.isListening = false;
        this.onResponse = (event) => {
            var _a;
            if (event.source !== this.target)
                return;
            const { type, payload } = event.data || {};
            if (type !== AJAX_RESPONSE || !(payload === null || payload === void 0 ? void 0 : payload.requestId))
                return;
            // It answers before the live content script does, so wait for that one
            if (((_a = payload.error) === null || _a === void 0 ? void 0 : _a.message) === EXTENSION_CONTEXT_INVALIDATED) {
                return;
            }
            const resolveRequest = this.pendingRequests.get(payload.requestId);
            if (!resolveRequest)
                return;
            this.pendingRequests.delete(payload.requestId);
            resolveRequest(payload);
        };
        const { target = window.parent } = params || {};
        this.target = target;
    }
    sendMessage(type, data) {
        const event = { type };
        if (data)
            event.payload = data;
        this.target.postMessage(event, this.origin);
    }
    // Sends HTTP request through extension service worker, so it's not affected by 3rd party cookies blocking
    request(params) {
        const { url, method = 'GET', headers, data, withCookies = true, timeout = DEFAULT_REQUEST_TIMEOUT } = params;
        const requestId = uuid();
        this.listenResponses();
        return new Promise((resolve, reject) => {
            const timer = setTimeout(() => {
                this.pendingRequests.delete(requestId);
                reject(new Error(`Extension request timeout: ${method} ${url}`));
            }, timeout);
            this.pendingRequests.set(requestId, response => {
                var _a;
                clearTimeout(timer);
                if (response.status) {
                    resolve(response);
                }
                else {
                    reject(new Error(((_a = response.error) === null || _a === void 0 ? void 0 : _a.message) || `Extension request failed: ${method} ${url}`));
                }
            });
            this.sendMessage(AJAX_REQUEST, {
                requestId,
                method,
                route: url,
                initialHeaders: headers,
                data,
                withCookies,
            });
        });
    }
    listenResponses() {
        if (this.isListening)
            return;
        this.isListening = true;
        window.addEventListener('message', this.onResponse, false);
    }
}
export const messaging = new Messaging();
